import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconThumbUpOutline from '@adv-mt/mt-svg-icons/lib/ThumbUpOutline'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body2} from '@adv-mt/ui/typography'

import {DRAWER_TYPES} from '../../../drawers/config.js'
import {BASE_CLASS} from './config.js'

const PriceIndicator = ({ad, onOpenDrawer}) => {
  const {domain} = useContext(Context)
  const {track: analyticsTrack} = useAnalyticsTrack()

  const config = domain.get('config')
  const {TRACKING_EVENT_NAMES} = config.get('tracking')
  const {PRICE_INDICATOR_COLOR_RANK, PRICE_INDICATOR_LABEL_RANK, PRICE_INDICATOR_VISIBLE_RANKS} =
    config.get('priceIndicator')

  const {priceRankIndicator} = ad

  if (!PRICE_INDICATOR_VISIBLE_RANKS.includes(priceRankIndicator)) return null

  const rankLabel = PRICE_INDICATOR_LABEL_RANK[priceRankIndicator]
  const rankColor = PRICE_INDICATOR_COLOR_RANK[priceRankIndicator]

  const onClickPriceIndicator = async () => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad,
      context: 'priceIndicator',
      event: TRACKING_EVENT_NAMES.PRICE_INDICATOR_CLICKED
    })

    analyticsTrack(eventData)
    onOpenDrawer({data: ad, type: DRAWER_TYPES.PRICE_INDICATOR})
  }

  const onKeyDownPriceIndicator = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onClickPriceIndicator()
  }

  return (
    <div
      className={cx(`${BASE_CLASS}-indicator`, {[`${BASE_CLASS}-indicator--${rankColor}`]: rankColor})}
      onClick={onClickPriceIndicator}
      onKeyDown={onKeyDownPriceIndicator}
      role="button"
      tabIndex={0}
    >
      <Icon size={ICON_SIZES.SM} className={`${BASE_CLASS}-indicatorLabelIcon`}>
        <IconThumbUpOutline size={ICON_SIZES.SM} />
      </Icon>

      <Body2 link highlight className={`${BASE_CLASS}-indicatorLabel`}>
        {rankLabel}
      </Body2>
    </div>
  )
}

PriceIndicator.displayName = 'PriceIndicator'
PriceIndicator.propTypes = {
  ad: PropTypes.object,
  onOpenDrawer: PropTypes.func.isRequired
}

export default PriceIndicator
